import lovet from '@src/configs/lovet';
import { TagTheme } from '@src/constants';

export const configMap = new Map<TagThemeType, BrandThemeConfig>([[TagTheme.Lovet, lovet]]);
